import { useRef, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
// import set3DSupport from "./set3DSupport.js";
import { addMarkers } from "./addMarkers";
import { flyToCOOPASV } from "./flyToCOOPASV";

import { useAppSelector } from "../../app/hooks";
import {
  selectListOfFieldBlocks,
  selectStatusListOfFieldBlocks,
} from "../../features/produtores/produtoresSlice";

mapboxgl.accessToken =
  "pk.eyJ1IjoiZ2VhZ3JvLWRyb25lcmVwb3J0IiwiYSI6ImNrcTh5c24zNDAzYjcyd282M3Bla3RqdngifQ.jJTDaf37MSuwYnvTnQl2Mg";

export default function Map() {
  let history = useHistory();
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lng] = useState(-47.935961);
  const [lat] = useState(-13.227878);
  const [zoom] = useState(2);

  useEffect(() => {
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [lng, lat],
      zoom: zoom,
    });
  });

  useEffect(() => {
    if (!map.current) return; // wait for map to initialize
    // map.current.on("move", () => {
    //   setLng(map.current.getCenter().lng.toFixed(4));
    //   setLat(map.current.getCenter().lat.toFixed(4));
    //   setZoom(map.current.getZoom().toFixed(2));
    // });
    // map.current.on("load", () => {
    //   set3DSupport(map.current);
    // });
  }, [map]);

  const listOfFieldBlocks = useAppSelector(selectListOfFieldBlocks);
  const statusListOfFieldBlocks = useAppSelector(selectStatusListOfFieldBlocks);

  useEffect(() => {
    if (!map.current) return; // wait for map to initialize

    if (statusListOfFieldBlocks === "success" && map.current) {
      addMarkers(map.current, listOfFieldBlocks, history);
      flyToCOOPASV(map.current);
    }
  }, [map, statusListOfFieldBlocks, listOfFieldBlocks, history]);

  return <div ref={mapContainer} className="map-container" />;
}
